/**
 * @generated SignedSource<<6e871f3d2133b80feb128b1c75db55b6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackagePriceDisplay_package$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useGetPackagePriceMap_package">;
  readonly " $fragmentType": "PackagePriceDisplay_package";
};
export type PackagePriceDisplay_package$key = {
  readonly " $data"?: PackagePriceDisplay_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackagePriceDisplay_package">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackagePriceDisplay_package",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetPackagePriceMap_package"
    }
  ],
  "type": "Package",
  "abstractKey": "__isPackage"
};

(node as any).hash = "76730957c6c10bf674d2207e1a217516";

export default node;
